/** @file The smallest scrollTop change that brings one fixed-height row fully into view. */

/** Returns `scrollTop` unchanged when row `index` is fully visible, else the nearest scrollTop that shows it. */
export function revealScrollTop(scrollTop: number, viewportHeight: number, rowHeight: number, index: number): number {
  const top = index * rowHeight;
  if (top < scrollTop) return top;
  const bottom = top + rowHeight;
  return bottom > scrollTop + viewportHeight ? bottom - viewportHeight : scrollTop;
}
